import urls from '../app/urls';
import request from '../utils/request';

export async function registerPusher() {
  await request.post(urls.initNotifications, {
    agent: 'web',
    cloudId: 'abc',
  });
}
